// Monto que paga el cliente en una forma de pago, con las promos que esa forma admite.
import type { PaymentOptionContext } from '@/domains/sales/wizard/steps/PaymentMethodStep';
import { formatMXN } from '@/shared/lib/format/money';
import { usePaymentTrackTotal } from '../hooks/usePaymentTrackTotal';

export function PaymentTrackTotal({
    sessionId,
    session,
    track,
    saleTotalCents,
}: PaymentOptionContext & { sessionId: string }) {
    const cents = usePaymentTrackTotal(sessionId, session, track, saleTotalCents);
    return <>{formatMXN(cents / 100)}</>;
}
